import React from 'react';
import clsx from 'clsx';
import { ReactComponent as InfoIcon } from 'common-assets/assets/icons/info-icon.svg';
import { ReactComponent as ErrorIcon } from 'common-assets/assets/icons/error-icon.svg';
import { ReactComponent as WarningIcon } from 'common-assets/assets/icons/warning-icon.svg';
import { ReactComponent as SuccessIcon } from 'common-assets/assets/icons/success-icon.svg';
import { Icon } from '../Icon/Icon';
import { Typography } from '../Typography/Typography';
import { TypographyFontWeightModel } from '../Typography/tools/Typography.model';

import useStyles from './AlertBox.style';

export interface AlertBoxProps {
  colorStyle?: 'blue' | 'red' | 'yellow' | 'green' | 'orange';
  title: string | React.ReactNode;
  subtitle?: React.ReactNode;
  thirdLine?: string;
  className?: string;
  testId?: string;
  titleFontWeight?: TypographyFontWeightModel;
}

const getIconByStyle = (colorStyle: NonNullable<AlertBoxProps['colorStyle']>, iconClassName: string): React.ReactNode => {
  const iconMap: Record<NonNullable<AlertBoxProps['colorStyle']>, React.ComponentType> = {
    blue: InfoIcon,
    red: ErrorIcon,
    yellow: WarningIcon,
    green: SuccessIcon,
    orange: WarningIcon,
  };

  const IconComponent = iconMap[colorStyle];
  return <Icon className={iconClassName}><IconComponent /></Icon>;
};

const AlertBox: React.FC<AlertBoxProps> = ({
  title,
  subtitle,
  thirdLine,
  className,
  testId,
  colorStyle = 'yellow',
  titleFontWeight = 'bold',
}) => {
  const c = useStyles({colorStyle});

  return (
    <div className={clsx(c.root, className)} data-testid={testId}>
      <div className={c.iconContainer}>
        {getIconByStyle(colorStyle, c.icon)}
      </div>
      <div className={c.textContainer}>
        <Typography fontWeight={titleFontWeight}>
          {title}
        </Typography>
        {subtitle && (
          <Typography>
            {subtitle}
          </Typography>
        )}
        {thirdLine && (
          <Typography>
            {thirdLine}
          </Typography>
        )}
      </div>
    </div>
  );
};

export {AlertBox};
